/**
 * 对象容器
 * 将公用对象都挂载到此容器中，方便调用
 */
export default {
	lastModel: 1,
	beforeCropModel: '',
	noMember(){
        $('.banner_box>#drag-zone').removeClass('active');
        $('.banner_box>.info_log').show();
        $('.header .right>.login>span').show()
        $('.photo_upgrade').removeClass('active');

        $('.login_box').hide();
        $('.login_btn>a').show();
        $('.photo_toggle_box>div span').removeClass('no');
        setCookie("user","",-1)
        user="";
    },
    LoginSuccess(){
        user=getCookie('user')
        if(user){
            user=JSON.parse(user)
            $.post(
                post_url+"product/trial",
                {
                    e_id:user.e_id,
                    t_id:user.t_id,
                    token:user.token,
                    p_id:this.product_id
                },
                function(data){
                }
            )
        }else{
            this.noMember();
        }
    },
    benefitStatus(successCallback,errorCallback){
        var parameter;
        var benefit1,benefit2
        if(user){
            parameter={
                e_id:user.e_id,
                t_id:user.t_id,
                token:user.token,
                product_id:this.product_id
            }
        }else{
            parameter={
                e_id:murmur,
                product_id:this.product_id
            }
        }
        var that=this
        $.post(
            post_url+'benefit/status',
            parameter,
            function(data){
                if(data.error==0){
                    benefit1=data.subscriptions
            
                    parameter.product_id=197
                    $.post(
                        post_url+'benefit/status',
                        parameter,
                        function(data){
                            if(data.error==0){
                                benefit2=data.subscriptions
                                if(benefit1.length>1 || benefit2.length>1){
                                    var quota=0
                                    var cost=0
                                    if(benefit2.length>1){
                                        var num=0
                                        for(var i=0;i<benefit2.length;i++){
                                            if(benefit2[i].product_feature==101){
                                                continue;
                                            }
                                            if(benefit2[i].benefits[0]['key']=='credit'){
                                                quota=quota+benefit2[i].benefits[0].quota*1
                                                cost=cost+benefit2[i].benefits[0].cost*1
                                                num++
                                            }
                                        }
                                        if(num>=1){
                                            benefit1[0].benefits[4].quota='1'
                                        }
                                        quota=parseInt(quota)
                                        cost=Math.ceil(cost)
                                    }
                                    benefit1[0].benefits[3].quota=benefit1[0].benefits[3].quota*1+quota
                                    benefit1[0].benefits[3].cost=benefit1[0].benefits[3].cost*1+cost
                                }
                                for(var i=0;i<benefit2[0].benefits.length;i++){
                                    switch(benefit2[0].benefits[i].key){
                                        case 'watermark.in_size':
                                            // in_size
                                            if(benefit2[0].benefits[i].quota*1==-1){
                                                if(benefit1[benefit1.length-1].benefits[0].limit*1<=benefit2[0].benefits[i].limit){
                                                    benefit1[benefit1.length-1].benefits[0].quota=-1
                                                }
                                            }else{
                                                benefit1[benefit1.length-1].benefits[0].quota=benefit2[0].benefits[i].quota*1+benefit1[benefit1.length-1].benefits[0].quota*1
                                                benefit1[benefit1.length-1].benefits[0].cost=benefit2[0].benefits[i].cost*1+benefit1[benefit1.length-1].benefits[0].cost*1
                                            }
                                            break;
                                        case 'watermark.in_edge':
                                            // in_edge
                                            if(benefit2[0].benefits[i].quota*1==-1){
                                                if(benefit1[benefit1.length-1].benefits[1].limit*1<=benefit2[0].benefits[i].limit){
                                                    benefit1[benefit1.length-1].benefits[1].quota=-1
                                                }
                                            }else{
                                                benefit1[benefit1.length-1].benefits[1].quota=benefit2[0].benefits[i].quota*1+benefit1[benefit1.length-1].benefits[1].quota*1
                                                benefit1[benefit1.length-1].benefits[1].cost=benefit2[0].benefits[i].cost*1+benefit1[benefit1.length-1].benefits[1].cost*1
                                            }
                                            break;
                                    }
                                }
                                that.subscriptions=benefit1
                                console.log(that.subscriptions)
                                successCallback()
                            }else{
                                try{
                                    errorCallback()
                                }catch(e){}
                                fail(VueI18n[lang]['error_268'+data.error]);
                            }
                        }
                    ).fail(function(){
                        fail(VueI18n[lang]['error_26899']);
                    })
                }else{
                    try{
                        errorCallback()
                    }catch(e){}
                    fail(VueI18n[lang]['error_268'+data.error]);
                }
            }
        ).fail(function(){
                $('.edit_box .load').hide();
                $('.edit_box>.uploadBox').show();
                overtime(26899);
        })
    },
    visitor2Login:'',
    downJson:'',
    manage(operation,data){
        // _gaq.push(['_trackEvent','Watermark Remover',operation,String(data)]);
    },
    brush_model:[],
    brush_size:[],
    subscriptions:null,
    original:0,
    token:'',
    // 0首次进入
    first:0,
    product_id:197
}